import React from 'react';
export const TutorIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
    <path d="M3 6V10" stroke="#343330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5.5 2V14" stroke="#343330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M8 4V12" stroke="#343330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M10.5 6V10" stroke="#343330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M13 5V11" stroke="#343330" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);